<template>
  <div>
    {{ tag }}
    <button class="delete-button" :id="`${tag}-tag-delete-button-` + index" @click="removeTag"><i class="fas fa-times delete-button-icon"></i></button>
  </div>
</template>

<script>
export default {
  name: 'Tags',

  props: {
    tag: {
      type: String,
      default: 'noprefix'
    },
  },

  methods: {    
    removeTag() {
      this.$emit('removed-tag', this.tag)
    },
  },
}
</script>

<style scoped>

.delete-button{
  background: none;
  background-size: cover;
  border: none;
  cursor: pointer;
}
.delete-button-icon{
  font-size: 12px;
  color: white;
}

</style>
